import React from 'react';
import { 
  FluentProvider, 
  webLightTheme, 
  webDarkTheme,
  makeStyles, 
  tokens,
  Switch,
} from '@fluentui/react-components';
import { useState } from 'react';

const useStyles = makeStyles({
  container: {
    width: '100vw',
    height: '100vh',
    backgroundColor: tokens.colorNeutralBackground1,
    margin: 0,
    padding: 0,
    fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif',
    boxSizing: 'border-box',
  },
  themeToggle: {
    position: 'fixed',
    top: tokens.spacingVerticalM,
    right: tokens.spacingHorizontalM,
    zIndex: 1000,
  },
});

const BlankSilhouette: React.FC = () => {
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const styles = useStyles();
  const theme = isDarkTheme ? webDarkTheme : webLightTheme;

  return (
    <FluentProvider theme={theme}>
      <div className={styles.container}>
        {/* Theme Toggle */}
        <div className={styles.themeToggle}>
          <Switch
            checked={isDarkTheme}
            onChange={(_, data) => setIsDarkTheme(data.checked)}
            label={isDarkTheme ? 'Dark theme' : 'Light theme'}
          />
        </div>

        {/* Empty canvas - build your components here */}
        
      </div>
    </FluentProvider>
  );
};

export default BlankSilhouette;
